import { Box, Divider, Flex, PopoverCloseButton, PopoverContent, PopoverHeader, Text, theme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import BlockContent from '@sanity/block-content-to-react';
import { rgba } from 'polished';
import { FC } from 'react';
import useBreakpoint from 'hooks/useBreakpoint';
import { rem } from 'utils/fonts';

const Wrapper = styled(PopoverContent)`
  position: absolute;
  flex-direction: column;
  width: 285px;
  min-height: 200px;
  background-color: ${theme.colors.white};
  padding: 20px;
  font-size: ${rem(12)};
  box-shadow: 0px 10px 20px ${rgba(theme.colors.black, 0.08)};
  z-index: 999;
  overflow: visible;

  &:focus {
    box-shadow: 0px 10px 20px ${rgba(theme.colors.black, 0.08)};
  }
`;

const Number = styled(Flex)<{ color: string }>`
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${(props): string => rgba(props.color, 0.13)};
  color: ${(props): string => props.color};
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

const HeaderWrapper = styled(PopoverHeader)`
  display: flex;
  align-items: center;
  margin-bottom: 13px;
  font-weight: bold;
  padding: 0;
  border-bottom: none;
`;

const StyledDivider = styled(Divider)`
  margin-top: 18px;
  margin-bottom: 18px;
`;

const Header = styled(Text)``;

const ActionText = styled(Box)``;

interface Props {
  title: string;
  number: string;
  subtitle: string;
  description: SanityRichText[];
  color: string;
}

const ClimateActionHint: FC<Props> = ({ title, number, description, subtitle, color }) => {
  const { isMobile } = useBreakpoint();

  return (
    <Wrapper bg="transparent" borderColor="transparent" border={0} borderRadius="medium">
      <HeaderWrapper>
        <Number color={color}>{number}</Number>
        <Header>{title}</Header>
      </HeaderWrapper>
      {isMobile && <PopoverCloseButton size="32px" color="gray.400" top="14px" />}
      <ActionText>{subtitle}</ActionText>
      <StyledDivider borderColor="gray.100" />
      <ActionText>
        <BlockContent blocks={description} />
      </ActionText>
    </Wrapper>
  );
};

export default ClimateActionHint;
